// each backend call should use this function to format the date to UTC format
export default function formatDateToUtcFormat(date?: Date | number) {
  return date ? new Date(date).toISOString() : new Date().toISOString();
}
